import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NightlightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nightlight"}/>
}
